import { DestroyRef, inject } from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';

export interface ValidatorsForForms {
  key: string;
  translation: string;
}

export abstract class BaseEditForm {
  protected readonly fb = inject(FormBuilder);
  protected readonly destroyRef = inject(DestroyRef);

  protected getNameValidators(): ValidatorFn[] {
    return [
      Validators.required,
      Validators.minLength(2),
      Validators.maxLength(50),
      Validators.pattern(/^[a-zA-ZÀ-ž\s'-]+$/),
    ];
  }

  protected getEmailValidators(): ValidatorFn[] {
    return [Validators.required, Validators.email, Validators.maxLength(100)];
  }

  protected getErrorMessage(
    form: FormGroup,
    controlName: string,
    validationErrors: Record<string, ValidatorsForForms[]>,
  ): string {
    const control = form.get(controlName);

    if (!control?.errors) {
      return '';
    }

    const controlErrors = validationErrors[controlName] ?? [];

    for (const error of controlErrors) {
      if (control.hasError(error.key)) {
        return error.translation;
      }
    }

    return '';
  }
}
